<div class="row">
    <div class="col-md-12">
        <div class="panel">
            <div
                class="panel-body"
                style="font-size: 17px"
            >
                <div
                    *ngIf="shoppingCartItemCount$ | async as itemCount; else emptyShoppingCart"
                    class="row justify-content-center"
                >
                    <div class="col-md-1 text-center">
                        <i
                            class="fa fa-check"
                            style="color:green; font-size:30px;"
                        ></i>
                    </div>
                    <div class="col-md-2 align-self-center">
                        <p style="text-align:center; color:green; font-weight:bold">Added to Cart</p>
                    </div>
                    <div class="col-md-4 align-self-center">
                        <div *ngIf="itemCount > 1; else singleItem">
                            <div>
                                <p style="text-align:center; color:black">
                                    <span style="font-weight:bold">Cart Subtotal </span>
                                    <span style="font-weight:normal">({{itemCount}} items): </span>
                                    <span style="color:maroon; font-weight:bold">{{ (shoppingCart$ | async).subTotal | currency : (shoppingCart$ | async).currencyCode: (shoppingCart$ | async).currencyCode + " "}}</span>
                                </p>
                            </div>
                        </div>
                        <ng-template #singleItem>
                            <div>
                                <p style="text-align:center; color:black">
                                    <span style="font-weight:bold">Cart Subtotal </span>
                                    <span style="font-weight:normal">({{itemCount}} item): </span>
                                    <span style="color:maroon; font-weight:bold">{{ (shoppingCart$ | async).subTotal | currency : (shoppingCart$ | async).currencyCode:(shoppingCart$ | async).currencyCode + " "}}</span>
                                </p>
                            </div>
                        </ng-template>
                    </div>
                    <div class="col-md-5 text-center">
                        <a
                            [routerLink]="isRegFlow ? ['/registration/order-summary'] : ['/shopping-cart']"
                            class="btn btn-warning checkout-btn"
                        ><b>Proceed to checkout</b></a>
                    </div>
                </div>
                <ng-template #emptyShoppingCart>
                    <div
                        class="col-md-12 pt-1"
                        style="text-align:center; font-weight:bolder"
                    >
                        <p>Your shopping cart is empty.</p>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
